import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-48",
  "use": "icon-icon-nav-48-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-48\"><path d=\"M545.472 495.296h234.176v50.176h-234.24v-50.176z m0-83.648h234.176v50.176h-234.24v-50.176z m0 167.232h234.176v50.24h-234.24v-50.24z m267.648-351.232h-602.24c-36.8 0-66.88 30.08-66.88 66.88v434.944c0 36.8 30.08 66.88 66.88 66.88h602.24c36.8 0 66.88-30.08 66.88-66.88V294.528c0-36.8-30.08-66.88-66.88-66.88z m0 501.76H512V294.592h301.12v434.944z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-48.svg
// module id = MTIt
// module chunks = 3